import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { Store } from '../../utils/toast'
import { serverUrl } from '../../request'
import { getAppType, getStorageKey } from '../../utils/appType'

const baseQuery = fetchBaseQuery({
  baseUrl: `${serverUrl}/api`,
  timeout: 5 * 60 * 1000,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(getStorageKey('token'))

    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }

    return headers
  },
})

let isHandlingUnauthorized = false

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const appType = getAppType()
  const url = typeof args === 'string' ? args : args.url
  const isAuthEndpoint = url.startsWith('/auth')

  let modifiedArgs: string | FetchArgs
  if (isAuthEndpoint) {
    modifiedArgs = args
  } else if (typeof args === 'string') {
    modifiedArgs = `/${appType}${args}`
  } else {
    modifiedArgs = { ...args, url: `/${appType}${args.url}` }
  }

  const result = await baseQuery(modifiedArgs, api, extraOptions)

  const errorStatus = result.error?.status
  const originalStatus =
    result.error && 'originalStatus' in result.error
      ? result.error.originalStatus
      : undefined

  const isUnauthorized =
    errorStatus === 401 ||
    originalStatus === 401 ||
    result.meta?.response?.status === 401

  if (result.error && isUnauthorized && !isHandlingUnauthorized) {
    isHandlingUnauthorized = true
    const loginPath = `/${appType}/login`

    Store.addNotification({
      title: 'ERROR',
      message: 'a expirat sesiunea',
      container: 'top-center',
      type: 'danger',
      insert: 'top',
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: {
        duration: 1000,
        onScreen: true,
      },
    })

    localStorage.removeItem(getStorageKey('token'))

    if (window.location.pathname !== loginPath) {
      window.location.replace(loginPath)
    }

    setTimeout(() => {
      isHandlingUnauthorized = false
    }, 1000)
  }

  return result
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: ({ endpointName, queryArgs }) => {
    const appType = getAppType()
    return `${appType}|${endpointName}|${JSON.stringify(queryArgs ?? null)}`
  },
  refetchOnMountOrArgChange: true,
  tagTypes: [
    'Categories',
    'Products',
    'GeneralInfo',
    'Ingredients',
    'Locations',
    'Orders',
    'Roulette',
    'Statistics',
    'AppStatus',
  ],
  endpoints: () => ({}),
})
